import { useMemo } from "react";

import { Plug } from "components/icons/generated";

import type { MainNavigationItem } from "../types";
import {
  MAIN_NAVIGATION_PRIMARY_MENU_ITEMS,
  MainNavigationPrimaryMenuItemKeys,
} from "./menuItemsPrimary";

const useIntegrateServicesGroup = (): MainNavigationItem => {
  return useMemo(
    () => ({
      id: "integrate-services",
      title: "Integrate Services",
      icon: Plug,
      items: [
        {
          items: [
            MAIN_NAVIGATION_PRIMARY_MENU_ITEMS[MainNavigationPrimaryMenuItemKeys.Integrations],
            MAIN_NAVIGATION_PRIMARY_MENU_ITEMS[MainNavigationPrimaryMenuItemKeys.Plugins],
          ],
        },
      ],
    }),
    []
  );
};

export default useIntegrateServicesGroup;
